/**
 * **Aus einem Kommentar wird eine Unteraufgabe** (09.09.2026,
 * [E-338](../../../docs/ENTSCHEIDUNGEN.md#e-338), Rückfall für die KI seit E-339).
 *
 * Nils: *„Macht es ggf. Sinn, dass man Kommentare als erledigt markieren kann?"* – Nein:
 * Kommentare sind Unterhaltung, das Häkchen hat die Unteraufgabe. Was fehlte, war der Weg
 * dorthin. Der Titel ist die **erste Textzeile** des Kommentars, ohne Markdown-Gerüst:
 * Bilder fallen weg, Links behalten ihren Text.
 *
 * **Erwähnungen** (E-340): eine Anrede ist kein Titel. In NCW-6X848M begannen neun von vierzehn
 * Kommentaren mit *„@Nils Waning"* auf einer eigenen Zeile – der Rückfall hätte neunmal
 * „Nils Waning" geheißen. Deshalb: eine Zeile, die nur aus Erwähnungen besteht, wird
 * übersprungen; Erwähnungen am **Anfang** einer Zeile fallen weg (Anrede); mitten im Satz
 * werden sie zum Namen (*„… mit Davin abstimmen"*).
 */
export const UNTERAUFGABE_TITEL_MAX = 200

const ERWAEHNUNG = /@\[([^\]]+)\]\(person:[^)]*\)/g

export function unteraufgabenTitel(body: string): string {
  const zeilen = body
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    .split('\n')
    .map((z) => {
      const ohneAnrede = z.replace(/^(?:\s*@\[[^\]]+\]\(person:[^)]*\)[\s,:;–-]*)+/, '')
      return ohneAnrede.replace(ERWAEHNUNG, '$1')
    })
    .map((z) =>
      z
        .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
        .replace(/^\s{0,3}(?:[-*+]|\d+[.)])\s+/, '')
        .replace(/^\s{0,3}#{1,6}\s+/, '')
        .replace(/[*_`~]+/g, '')
        .trim(),
    )
    .filter((z) => z.length > 0)
  const erste = zeilen[0] ?? ''
  return erste.length > UNTERAUFGABE_TITEL_MAX
    ? `${erste.slice(0, UNTERAUFGABE_TITEL_MAX - 1).trimEnd()}…`
    : erste
}
